import { render, staticRenderFns } from "./ProgramTalksTopics.vue?vue&type=template&id=59ab0fd8&"
import script from "./ProgramTalksTopics.vue?vue&type=script&lang=js&"
export * from "./ProgramTalksTopics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports